import { useModal } from "context/modal-context";
import ContactUsModal from "components/modal/contact-us-modal";
import HireTalentModal from "components/modal/hire-talent-modal";
import ManagedServiceModal from "components/modal/managed-service-modal";
import CorporateTrainingModal from "components/modal/corporate-training-modal";
import IndividualTrainingModal from "components/modal/individual-training-modal";
import StartProjectModal from "components/modal/start-project-modal";
import BecomePartnerModal from "components/modal/become-partner-modal";
import contactImage from "assets/png/contact.png";

const ServiceModal = () => {
  const { activeModal, closeModal } = useModal();

  return (
    <>
      <ContactUsModal
        open={activeModal === "get-in-touch"}
        handleClose={closeModal}
        image={contactImage}
      />
      <HireTalentModal
        open={activeModal === "hire-talent"}
        handleClose={closeModal}
      />
      <ManagedServiceModal
        open={activeModal === "managed-service"}
        handleClose={closeModal}
      />
      <CorporateTrainingModal
        open={activeModal === "corporate-training"}
        handleClose={closeModal}
      />
      <IndividualTrainingModal
        open={activeModal === "individual-training"}
        handleClose={closeModal}
      />
      <StartProjectModal
        open={activeModal === "start-project"}
        handleClose={closeModal}
      />
      <BecomePartnerModal
        open={activeModal === "become-partner"}
        handleClose={closeModal}
      />
    </>
  );
};

export default ServiceModal;
